import { createFileRoute } from '@tanstack/react-router';
import { RequirePermission } from '../../../features/layout/RequirePermission';
import { z } from 'zod';
import { ADMIN_SYNC_STATUSES } from '@itvisits/shared';
import { AdminSyncPage } from '../../../features/admin/admin-sync/AdminSyncPage';

const searchSchema = z.object({
  q: z.string().catch(''),
  status: z.enum(['all', 'attention', ...ADMIN_SYNC_STATUSES]).catch('all'),
});

export const Route = createFileRoute('/_authed/admin/admin-sync')({
  validateSearch: searchSchema,
  component: Guarded,
});

function AdminSyncRoute(): React.JSX.Element {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AdminSyncPage
      search={search}
      onSearch={(next) => void navigate({ search: next, replace: true })}
    />
  );
}

function Guarded(): React.JSX.Element {
  return (
    <RequirePermission permission="admin_sync.manage">
      <AdminSyncRoute />
    </RequirePermission>
  );
}
